export class DocumentRequiredTableConfig {
  getConfigDocRequiredList() {
    const listSpecialDocId = [3, 5];
    const listObjDocIdNewDocNotChange: any = [];
    const listObjDocIdRemarkNotChange: any = [];
    const listObjDocIdDraftDoc = [1, 15, 16, 17, 18, 42, 49];
    const listObjDocIdOriginalDoc = [1, 14];
    const listObjDocIdCBKOriginalDoc = [15, 16, 18];
    const listObjDocIdTruckBillOriginalDoc = [67,19];
    const ignoreFields = [
      'listDocLabel',
      'applicantName',
      'invoiceNo',
      'noNeedDraft',
      'seaContQuarantineDeclShow2Vessel',
      'packingDeclShow2Vessel',
      'coaApplicantName',
      'other1Text',
      'other2Text',
      'other3Text',
    ];
    return {
      listSpecialDocId,
      listObjDocIdNewDocNotChange,
      listObjDocIdRemarkNotChange,
      listObjDocIdDraftDoc,
      listObjDocIdOriginalDoc,
      ignoreFields,
      listObjDocIdCBKOriginalDoc,
      listObjDocIdTruckBillOriginalDoc
    };
  }
}
